import React, { useEffect, useState } from "react";
import { Grid, Header, Button, Form } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import axios from "axios";
import { BaseUrl } from "../formcomponents/Constants";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { userData } from "../store/userData";
import { reduxForm, Field } from "redux-form";
const CusVisaList = (props) => {
  const { visaCategoryId } = props;
  const navigate = useNavigate();
  const userDectail = userData();
  const [excelData, setexcelData] = useState([]);
  const [rowData, setrowData] = useState([]);

  useEffect(() => {
    getVisaList();

    console.log("userDectail", userDectail.userId);
  }, []);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const filterDataSearch = () => {
    const fromDateObj = new Date(fromDate);
    fromDateObj.setHours(0, 0, 0, 0); // Set time to midnight
    const toDateObj = new Date(toDate);
    toDateObj.setHours(23, 59, 59, 999); // Set time to end of day

    const filteredData = excelData.filter((data) => {
      // Parse the date string into a Date object
      const dateParts = data.applicationDate.split("/");
      const parsedDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
      parsedDate.setHours(0, 0, 0, 0); // Set time to midnight

      return parsedDate >= fromDateObj && parsedDate <= toDateObj;
    });

    setexcelData(filteredData);
    setrowData(filteredData);
  };

  const getVisaList = () => {
    axios
      .post(BaseUrl + "listSSVisa", {
        userId: userDectail.userId,
        visaCategoryId: visaCategoryId,
        getAll: visaCategoryId === 0 ? true : false,
        visaTypeNumber: 2,
      })
      .then((res) => {
        console.log(res.data);

        setDataForExcel(res.data);
        const updatedRowData = res.data.map((item) => ({
          ...item,
          applicationDate: item.applicationDate
            ? new Date(item.applicationDate).toLocaleDateString("en-GB")
            : "",
        }));
        setrowData(updatedRowData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setDataForExcel = (record) => {
    const tempRecord = record.map(
      ({
        ssVisaId,
        serialNumber,
        applicationDate,
        customerName,
        applicantName,
        passportNumber,
        passportExpiry,
        nationality,
        id,
        visaType,
        visaCost,
        invoice,

        remarks,
        status,
      }) => ({
        ssVisaId,
        serialNumber,
        applicationDate: applicationDate
          ? new Date(applicationDate).toLocaleDateString("en-GB")
          : "",
        customerName,
        applicantName,
        passportNumber,
        passportExpiry: passportExpiry
          ? new Date(applicationDate).toLocaleDateString("en-GB")
          : "",
        nationality,
        ID_PAN: id,
        visaType,
        visaCost,
        invoice,

        remarks,
        status,
      })
    );
    setexcelData(tempRecord);
  };
  const defaultColDef = {
    sortable: true,
    editable: true,
    // flex: 1,
    filter: true,
    floatingFilter: true,
  };

  const columnDefs = [
    { headerName: "SR Number", field: "serialNumber" },
    { headerName: "Date", field: "applicationDate" }, //customerName
    { headerName: "Request Person", field: "customerName" },
    { headerName: "Applicant Name", field: "applicantName" },
    { headerName: "Passport Num", field: "passportNumber" },
    { headerName: "Passport Expiry", field: "passportExpiry" },

    { headerName: "Nationality", field: "nationality" },
    { headerName: "ID/PAN", field: "id" },
    { headerName: "Visa Type", field: "visaType" },
    { headerName: "Cost", field: "visaCost" },
    { headerName: "Invoice", field: "invoice" },
    { headerName: "Remark", field: "remarks" },
    { headerName: "Status", field: "status" },
    { headerName: "Customer Name", field: "customerName" },

    {
      headerName: "Edit/Delete",
      filter: false,
      field: "ssVisaId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => updateRecord(params)}>
            <AiFillEdit />
          </Button>
          <Button color="red" onClick={() => deleteRecord(params)}>
            <AiFillDelete />
          </Button>
        </div>
      ),
    },
  ];

  const updateRecord = (params) => {
    navigate(`/new-cus-visa-create/${params.data.ssVisaId}/${visaCategoryId}`);
  };
  const deleteRecord = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(BaseUrl + "deleteSSVisa", {
            ssVisaId: params.data.ssVisaId,
          })
          .then((res) => {
            console.log("res", res.data);
            Swal.fire("Deleted!", "Visa Recored has been deleted.", "success");
            getVisaList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  return (
    <div>
      <br />
      <Grid.Row>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            {visaCategoryId != 0 && (
              <Button
                color="primary"
                onClick={() =>
                  navigate(`/new-cus-visa-create/null/${visaCategoryId}`)
                }
              >
                Create New
              </Button>
            )}

            <Button
              color="primary"
              onClick={(e) => exportToCSV(excelData, "Visa_List")}
            >
              Export Excel
            </Button>
          </div>
          <div
            style={{
              display: "flex",
            }}
          >
            <Form.Input
              name="from"
              label="from"
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
            <Form.Input
              name="to"
              label="To"
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
            <Button color="primary" onClick={(e) => filterDataSearch()}>
              Filter Search
            </Button>
          </div>
        </div>
      </Grid.Row>
      <br />
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
          ></AgGridReact>
        </div>
      </Grid.Row>
    </div>
  );
};

export default CusVisaList;
